<script setup>
import { VueFlow, useVueFlow } from '@vue-flow/core';
import { uid } from './model';

const props = defineProps({
  flow: { type: Object, required: true },
  nodeTypes: { type: Object, required: true },
});
defineEmits([
  'connect',
  'nodeClick',
  'edgeClick',
  'nodeDragStart',
  'nodeDragStop',
]);

// Each mounted canvas owns one document object and one Vue Flow store. In
// particular, seed flows may legitimately reuse node IDs such as "event".
// Never rebind a live store's two-way models to a different flow/group.
const canvasFlow = props.flow;
const canvasId = `placement-canvas-${uid()}`;
const { fitView, zoomIn, zoomOut } = useVueFlow(canvasId);
defineExpose({ fitView, zoomIn, zoomOut });
</script>

<template>
  <VueFlow
    :id="canvasId"
    v-model:nodes="canvasFlow.nodes"
    v-model:edges="canvasFlow.edges"
    :node-types="nodeTypes"
    :min-zoom="0.25"
    :max-zoom="2"
    fit-view-on-init
    :delete-key-code="null"
    class="automation-canvas"
    @connect="$emit('connect', $event)"
    @node-click="$emit('nodeClick', $event)"
    @edge-click="$emit('edgeClick', $event)"
    @node-drag-start="$emit('nodeDragStart', $event)"
    @node-drag-stop="$emit('nodeDragStop', $event)"
  />
</template>
